<template>
  <div class="bg-black bg-opacity-80 w-screen h-screen fixed top-0 left-0 flex justify-center items-center">
    <div class="w-full h-full flex flex-col">
      <header class="bg-primary h-2/12 w-full px-4 py-2">
        <h2 class="text-3xl text-white font-bold inline">{{ book.id }} - {{ book.name }}</h2>
        <i
          @click="close()"
          class="helper float-right mr-2 items-center border-0"
        >
          <FontAwesomeIcon icon="times" />
        </i>
      </header>
      <figure class="text-center h-full p-4 box-border m-auto">
        <button
          :disabled="selectedPage === 0"
          @click="flip(-1)"
          class="helper fixed left-4 top-1/2"
        >
          &larr;
        </button>
        <button
          :disabled="parseInt(selectedPage) + 1 >= book.pages.length"
          @click="flip(1)"
          class="helper fixed right-4 top-1/2"
        >
          &rarr;
        </button>
        <transition name="transition-1" mode="out-in">
          <img
            v-if="imgLoaded === 1"
            class="h-full "
            :style="`background-image: url(${book.pages[selectedPage]})`"
            src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
          />
          <h3 v-else-if="imgLoaded === -1">
            Erro no carregamento da imagem. Tente mais tarde ou entre em contato com a PK.
            (ID do livro: {{ book.id }})
          </h3>
          <FontAwesomeIcon
            v-else
            class="spinner"
            icon="circle-notch"
            spin
          />
        </transition>
        <figcaption class="fixed bottom-4 right-4 bg-primary p-4 text-white rounded-md border-2 border-white border-solid">
          <input class="w-12 h-10 text-center bg-transparent border border-white " size="2" v-model="selectedPage" type="number" />
          <strong> / {{book.pages.length - 1}}</strong>
        </figcaption>
      </figure>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BookReader',
  props: {
    book: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      selectedPage: 0,
      imgLoaded: 0
    }
  },
  watch: {
    selectedPage (next, prev) {
      if (next > this.book.pages.length - 1) {
        this.selectedPage = this.book.pages.length - 1
      } else if (next < 0) {
        this.selectedPage = 0
      }
      this.loadImage(this.book.pages[next])
    }
  },
  methods: {
    flip (n) {
      this.selectedPage = parseInt(this.selectedPage) + n
    },
    keyNav (ev) {
      if (ev.key === 'Escape') {
        this.close()
      } else if (ev.keyCode === 37) {
        this.flip(-1)
      } else if (ev.keyCode === 39) {
        this.flip(1)
      }
    },
    close () {
      this.$emit('closed', true)
    },
    async loadImage (i) {
      let img
      this.imgLoaded = 0
      const imageLoadPromise = new Promise((resolve, reject) => {
        img = new Image()
        img.onload = resolve
        img.onerror = reject
        img.src = i
      }).then(
        () => {
          this.imgLoaded = 1
        }
      ).catch(
        () => {
          this.imgLoaded = -1
        }
      )
      await imageLoadPromise
    }
  },
  mounted () {
    this.loadImage(this.book.pages[0])
    window.addEventListener('keyup', this.keyNav)
  },
  beforeDestroy () {
    window.removeEventListener('keyup', this.keyNav)
  }
}
</script>

<style lang="scss" scoped>
img {
  background: {
    size: contain;
    repeat: no-repeat;
    position: center;
  }
}
.spinner {
  font-size: 5rem;
  margin-top: 30vh;
  color: white
}
h3 {
  font-size: 3rem;
  margin-top: 30vh;
  color: white;
  max-width: 720px;
  width: 80%;
}
.helper {
  @apply border-2 cursor-pointer border-solid text-2xl w-10 h-10 text-center bg-primary font-bold border-white rounded-full text-white flex items-center justify-center;
  &:disabled {
    @apply bg-gray-400;
  }
  &:hover {
    @apply bg-white text-primary;
  }
}
</style>
